import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import HotPledges from '@components/modules/Poll/HotPledges';
import { FormattedPoll } from '@utils/Poll';

const HotPledgePage: React.FC = () => {
  const history = useHistory<any>();

  const onPollSelect = useCallback(
    (poll: FormattedPoll) => {
      history.push(`/poll/${poll.id}`);
    },
    [history]
  );

  return (
    <>
      <HotPledges onSelectPoll={onPollSelect} />
    </>
  );
};

export default HotPledgePage;
